<div
    class="bg-gray-50 dark:bg-gray-900 h-screen  sm:max-h-[calc(100vh-140px)] max-h-[calc(100vh-120px)] flex flex-col w-full">
    <!-- Indicador de estado de conexión WebSocket -->
    @if (!wsConnected || connectionFailed) {
    <div class="connection-status-bar p-2 flex items-center justify-between transition-all" [ngClass]="{'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100': !wsConnected && !connectionFailed,
                     'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100': connectionFailed}">
        <div class="flex items-center">
            <mat-icon class="mr-2">{{connectionFailed ? 'error_outline' : 'wifi_off'}}</mat-icon>
            <span>{{ connectionFailed ? 'No se pudo reconectar al servidor' : 'Conexión perdida. Intentando reconectar...' }}</span>
        </div>
        @if (connectionFailed) {
        <button mat-button color="warn" (click)="reloadPage()">
            <span class="mr-1">Recargar página</span>
            <mat-icon>refresh</mat-icon>
        </button>
        }

    </div>
    }

    <div class="flex-grow overflow-hidden">
        @if(isLoading){
        <div class="h-full flex items-center justify-center" @fadeRoutineChange>
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        } @else {
        <!-- Control de navegación para móviles -->
        <div
            class="md:hidden sticky top-0 z-10 bg-white dark:bg-gray-800 shadow-sm px-4 py-2 flex justify-between items-center">
            <h1 class="text-lg font-medium dark:text-white">Rutina manual</h1>
            <div class="flex space-x-2">
                <button mat-stroked-button [class.bg-blue-100]="mobileView === 'field'"
                    [class.dark:bg-blue-900]="mobileView === 'field'" (click)="setMobileView('field')"
                    class="text-sm rounded-lg px-3 py-1 flex items-center border-none">
                    <mat-icon class="mr-1 text-sm">sports_soccer</mat-icon>
                    Campo
                </button>
                <button mat-stroked-button [class.bg-blue-100]="mobileView === 'config'"
                    [class.dark:bg-blue-900]="mobileView === 'config'" (click)="setMobileView('config')"
                    class="text-sm rounded-lg px-3 py-1 flex items-center border-none">
                    <mat-icon class="mr-1 text-sm">settings</mat-icon>
                    Config
                </button>
            </div>
        </div>

        <div class="h-full flex flex-col md:flex-row overflow-hidden">
            <!-- Panel de controles -->
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow m-3 h-full max-h-[calc(100vh-190px)] md:w-1/2 flex flex-col overflow-hidden"
                [class.hidden]="mobileView === 'field' && !deviceIsMd"
                [class.block]="mobileView === 'config' || deviceIsMd">
                <div class="p-4 bg-blue-100 dark:bg-gray-700 border-b dark:border-gray-700">
                    <h2 class="text-lg font-medium text-blue-900 dark:text-blue-100">Configuración</h2>
                </div>

                <!-- Área de parámetros con estilo tarjeta -->
                <div class="p-4 space-y-4 overflow-y-auto">

                    <!-- Botón para re-seleccionar divisiones -->
                    @if (divisions.length > 1) {
                    <div class="flex justify-end mb-2">
                        <button mat-button (click)="openDivisionModal()" class="text-xs">
                            <mat-icon class="mr-1 text-sm">edit</mat-icon>
                            Cambiar Divisiones
                        </button>
                    </div>
                    }

                    <!-- Selector de acomodo con estilo mejorado -->
                    <div>
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 block">Acomodo</label>
                        <mat-form-field appearance="fill" class="w-full">
                            <mat-select [value]="selectedCluster?.id" (selectionChange)="onClusterChange($event.value)"
                                class="w-full">
                                @for (cluster of filteredClusterData$; track cluster.id) {
                                <mat-option [value]="cluster.id">
                                    {{ cluster.name }}
                                </mat-option>
                                }

                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div>
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 block">Tipo de
                            rutina</label>
                        <mat-form-field appearance="fill" class="w-full">
                            <mat-select [value]="selectedRoutineType?.id" [disabled]="routine.length > 0"
                                (selectionChange)="onRoutineTypeChange($event.value)" class="w-full">
                                @for (routineType of routineTypes; track routineType.id) {
                                <mat-option [value]="routineType.id">
                                    {{ routineType.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    @if (selectedRoutineType?.id === 1) {
                    <!-- Tiempos con valores numéricos y etiquetas más claras -->
                    <div>
                        <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tiempos (segundos)</h3>
                        <div class="grid grid-cols-3 gap-2">
                            <div class="flex flex-col">
                                <label class="text-xs text-gray-500 dark:text-gray-400 mb-1 ml-1">Verde</label>
                                <input type="number" [(ngModel)]="greenTime" min="0.1" max="60" title=""
                                    class="border dark:border-gray-600 rounded-md px-2 py-1 text-center focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-200" />
                            </div>

                            <div class="flex flex-col">
                                <label class="text-xs text-gray-500 dark:text-gray-400 mb-1 ml-1">Amarillo</label>
                                <input type="number" [(ngModel)]="yellowTime" min="0.1" max="60" title=""
                                    class="border dark:border-gray-600 rounded-md px-2 py-1 text-center focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-200" />
                            </div>

                            <div class="flex flex-col">
                                <label class="text-xs text-gray-500 dark:text-gray-400 mb-1 ml-1">Rojo</label>
                                <input type="number" [(ngModel)]="redTime" min="0.1" max="60" title=""
                                    class="border dark:border-gray-600 rounded-md px-2 py-1 text-center focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-200" />
                            </div>
                        </div>
                    </div>
                    }
                    @else if (selectedRoutineType?.id === 2) {
                    <div>
                        <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Parámetros</h3>
                        <div class="border rounded-md pb-4 px-4 pt-2 dark:border-gray-700">
                            <div class="grid grid-cols-2 gap-4">
                                <!-- Campos con altura fija igual -->
                                <div>
                                    <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Tiempo</label>
                                    <mat-form-field appearance="fill" class="w-full input-field-container">
                                        <input matInput type="number" [(ngModel)]="colorTime" min="0.1" max="60"
                                            class="text-center" />
                                    </mat-form-field>
                                </div>

                                <div>
                                    <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Color</label>
                                    <mat-form-field appearance="fill" class="w-full input-field-container">
                                        <mat-select [(ngModel)]="colorId">
                                            @for (color of ESP_COLOR_AVAILABLES; track color.id) {
                                            <mat-option [value]="color.id">
                                                <span class="color-dot"
                                                    [style.backgroundColor]="'rgb(' + color.color_code + ')'"></span>
                                                {{ color.name_color }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-t dark:border-gray-700 pt-3 pb-6">
                        <h3
                            class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex justify-between items-center">
                            <span>Secuencia de rutina</span>
                            <span
                                class="text-xs bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 py-0.5 px-2 rounded-full">{{routine.length}}
                                pasos</span>
                        </h3>

                        @if (routine.length > 0) {
                        <div class="h-72 overflow-y-auto border dark:border-gray-700 rounded">
                            <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                                <thead class="bg-gray-50 dark:bg-gray-700 sticky top-0">
                                    <tr>
                                        <th
                                            class="px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-300 tracking-wider text-left">
                                            Pos</th>
                                        <th
                                            class="px-1 py-2 text-sm font-medium text-gray-500 dark:text-gray-300 tracking-wider text-center">
                                            V</th>
                                        <th
                                            class="px-1 py-2 text-sm font-medium text-gray-500 dark:text-gray-300 tracking-wider text-center">
                                            A</th>
                                        <th
                                            class="px-1 py-2 text-sm font-medium text-gray-500 dark:text-gray-300 tracking-wider text-center">
                                            R</th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                    @for (element of routine; track $index) {
                                    <tr>
                                        <td class="px-3 py-2 whitespace-nowrap text-sm dark:text-gray-300">
                                            {{element.position}}
                                        </td>
                                        <td class="px-1 py-2 whitespace-nowrap text-sm text-center dark:text-gray-300">
                                            <span>{{element.g}}</span>
                                        </td>
                                        <td class="px-1 py-2 whitespace-nowrap text-sm text-center dark:text-gray-300">
                                            <span>{{element.y}}</span>
                                        </td>
                                        <td class="px-1 py-2 whitespace-nowrap text-sm text-center dark:text-gray-300">
                                            <span>{{element.r}}</span>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        } @else {
                        <div
                            class="text-center border dark:border-gray-700 rounded py-6 text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-700 flex flex-col items-center justify-center">
                            <mat-icon class="mb-2 text-gray-300 dark:text-gray-600"
                                style="width:40px; height:40px; font-size:40px;">sports_soccer</mat-icon>
                            <p class="text-sm dark:text-gray-400">Selecciona posiciones en el campo</p>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>

            <!-- Panel del campo de fútbol -->
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow m-3 flex-grow flex flex-col overflow-hidden max-h-[calc(100vh-190px)]"
                [class.hidden]="mobileView === 'config' && !deviceIsMd"
                [class.block]="mobileView === 'field' || deviceIsMd">
                <div
                    class="p-4 border-b dark:border-gray-700 flex items-center bg-blue-100 dark:bg-gray-700 justify-between">
                    <h2 class="text-lg font-medium dark:text-white">Campo</h2>
                    @if (uuid) {<button mat-button class="bg-red-900 text-white"
                        (click)="stopRoutine()">Detener</button>}
                </div>

                <div class="flex-grow p-4 flex items-start justify-center overflow-auto">
                    <div class="max-w-2xl overflow-auto">
                        <app-field-grid src="assets/images/cluster/Plano_Campo.webp" alt="Plano campo fútbol"
                            [numCols]="numCols" [typesDevices]="typesDevicesForGrid" [tableData]="tableData"
                            [status]="0" [isRoutine]="true" (imageLoaded)="onImageLoad($event)"
                            [routine]="{ cluster: selectedCluster }" [allDevices]="devices"
                            [devicesStatus]="devicesStatus" (cellClick)="selectTypeDevice($event.row, $event.col)"
                            (cellRightClick)="onCellRightClick($event)">
                        </app-field-grid>
                    </div>
                </div>

            </div>
        </div>
        }
    </div>
</div>

<ng-template #divisionModal>
    <div class="p-4 sm:p-6 w-full max-w-[90vw] sm:max-w-[400px] md:max-w-[500px]">
        <mat-dialog-content class="mat-typography mb-4">
            <h2 class="text-lg sm:text-xl font-medium dark:text-white">Selecciona las divisiones de la
                rutina:</h2>
        </mat-dialog-content>
        <form [formGroup]="divisionForm">
            <div class="mt-4 sm:mt-6">
                <span class="mb-1 font-medium leading-tight text-sm sm:text-base dark:text-gray-300">Divisiones</span>
                <div class="mt-2 rounded-md border border-gray-300 dark:border-gray-500 shadow-sm overflow-hidden">
                    <div
                        class="h-44 sm:h-56 md:h-64 leading-none overflow-y-auto border-t border-gray-300 dark:border-gray-500">
                        @for (division of divisions; track trackByFn($index, division)) {
                        <mat-checkbox
                            class="flex items-center h-10 sm:h-12 min-h-10 sm:min-h-12 pl-2 sm:pl-3 pr-4 sm:pr-6"
                            [color]="'primary'"
                            [checked]="isDivisionSelected(division.id)"
                            (change)="toggleDivision(division, $event)">
                            <span class="text-sm sm:text-base dark:text-gray-300">{{division.name}}</span>
                        </mat-checkbox>
                        }
                    </div>
                </div>
            </div>
        </form>
        <mat-dialog-actions class="flex justify-end mt-4 sm:mt-6">
            <button mat-button [disabled]="!divisionForm.get('divisions').value.length" (click)="closeDivisionModal()"
                class="px-4 sm:px-6 py-1 sm:py-2 text-sm sm:text-base">
                Aceptar
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>
